import { tss } from "tss-react/mui";

export const useEditorialSectionStyles = tss.withName("EditorialSection").create(({ theme }) => ({
    imageRoot: {
        padding: "0",
    },
    imageLayout: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        minHeight: 560,
        [theme.breakpoints.down("md")]: {
            gridTemplateColumns: "1fr",
            minHeight: "auto",
        },
    },
    imageWrapper: {
        position: "relative" as const,
        [theme.breakpoints.down("md")]: {
            height: 360,
        },
    },
    image: {
        width: "100%",
        height: "100%",
        objectFit: "cover" as const,
        display: "block",
    },
    textWrapper: {
        display: "flex",
        flexDirection: "column" as const,
        justifyContent: "center",
        padding: "88px 8%",
        backgroundColor: theme.palette.background.paper,
        [theme.breakpoints.down("sm")]: {
            padding: "56px 6%",
        },
    },
    title: {
        margin: "16px 0 24px",
    },
    body: {
        color: theme.palette.text.secondary,
        lineHeight: 1.8,
        maxWidth: 440,
    },
    typographicRoot: {
        backgroundColor: theme.palette.primary[50],
        padding: "120px 6%",
        textAlign: "center" as const,
        [theme.breakpoints.down("sm")]: {
            padding: "72px 6%",
        },
    },
    typographicInner: {
        maxWidth: 720,
        margin: "0 auto",
    },
    typographicTitle: {
        margin: "16px 0 24px",
    },
    typographicBody: {
        color: theme.palette.text.secondary,
        lineHeight: 1.8,
        maxWidth: 560,
        margin: "0 auto",
    },
}));
